import axios from 'axios'

export default {
  getChains() {
      return axios.get('/api/customerchains/lookup');
  }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/chainselector/api.js